import React, { useState, useEffect, useCallback } from "react";
import "./Specialists.css";
// import SiteCrews from "../components/SiteCrews/SiteCrews";
import kalpataruImg from "../assets/kalpataru-modular-kitchen.jpg";
import ardraImg from "../assets/ardra-wardrobe-system.jpg";
import terraImg from "../assets/terra.png";
import marinusImg from "../assets/marinus-furniture-atelier.jpg";
import chairCoImg from "../assets/chair-and-co-showroom.jpg";
import lumeBrassImg from "../assets/lume-and-brass-showroom.jpg";
import ferraraImg from "../assets/ferrara-hardware-studio.jpg";
import maatiImg from "../assets/maati-objects-ceramics.jpg";
import workshopPromiseImg from "../assets/riverstone-residence.jpg";

const stats = [
  { value: "14", label: "Partner companies" },
  { value: "4", label: "Specialist categories" },
  { value: "60+", label: "Products in one home" },
  { value: "9 yrs", label: "Average craft experience" },
];

const collaborators = [
  { initials: "KM", name: "Kalpataru Modular Works" },
  { initials: "AW", name: "Ardra Wardrobe Systems" },
  { initials: "TU", name: "Terra Upholstery Studio" },
  { initials: "MF", name: "Marinus Furniture Atelier" },
  { initials: "SP", name: "Shubh POP & Paint Works" },
  { initials: "VC", name: "Vishwakarma Site Carpentry" },
  { initials: "SM", name: "Setu MEP Consultants" },
];

const manufacturers = [
  {
    img: kalpataruImg,
    alt: "Graphite modular kitchen manufactured by Kalpataru Modular Works",
    eyebrow: "Modular Kitchen Manufacturer",
    name: "Kalpataru Modular Works",
    meta: "Baner · Since 2011",
    desc: "A CNC-driven factory that builds every Dwellora kitchen to the millimetre.",
    tags: ["Kitchen carcasses", "Shutter systems", "Quartz counters", "Tall units & pantries"],
  },
  {
    img: ardraImg,
    alt: "Fluted wardrobe system with brass hardware by Ardra Wardrobe Systems",
    eyebrow: "Wardrobe & Storage Manufacturer",
    name: "Ardra Wardrobe Systems",
    meta: "Pirangut · Since 2014",
    desc: "Storage engineered like furniture — soft-close, dust-sealed and built to order.",
    tags: ["Walk-in wardrobes", "Sliding systems", "Fluted panels", "Internal organisers"],
  },
  {
    img: terraImg,
    alt: "Upholstery craftsman at Terra Upholstery Studio fitting fabric to a chair frame",
    eyebrow: "Upholstery Atelier",
    name: "Terra Upholstery Studio",
    meta: "Koregaon Park · Since 2009",
    desc: "Hand-stitched frames and fabric work from a three-generation atelier.",
    tags: ["Sofas & sectionals", "Headboards", "Accent chairs", "Soft wall panels"],
  },
  {
    img: marinusImg,
    alt: "Custom oak bed and joinery by Marinus Furniture Atelier",
    eyebrow: "Custom Furniture Maker",
    name: "Marinus Furniture Atelier",
    meta: "Bhosari · Since 2012",
    desc: "Solid-wood and veneer furniture, made piece by piece for each Dwellora home.",
    tags: ["Beds & side tables", "Dining tables", "Consoles", "Study & TV units"],
  },
];

const consultants = [
  {
    eyebrow: "Lighting Design Consultants",
    name: "Lumen House",
    desc: "Decide where light falls, not just which fixture hangs — lux planning, layering and dimming scenes for every room.",
  },
  {
    eyebrow: "Electrical, Plumbing & HVAC",
    name: "Setu MEP Consultants",
    desc: "Load calculations, circuit maps and wet-area planning that keep the services invisible and the switchboard sane.",
  },
  {
    eyebrow: "Civil & Structural Specialists",
    name: "Aranya Civil & Waterproofing",
    desc: "Structural changes, bathroom waterproofing and flooring levels — done once, with a written warranty.",
  },
  {
    eyebrow: "3D Visualisation Partners",
    name: "Studio Naksha",
    desc: "Photoreal views of your home before a single panel is cut — so every decision is made on screen, not on site.",
  },
];

const decorPartners = [
  {
    img: chairCoImg,
    alt: "Accent chairs and curved sofa in the Chair & Co. showroom",
    eyebrow: "Loose Furniture Store",
    name: "Chair & Co.",
    meta: "KP · Flagship showroom",
    tags: ["Accent chairs", "Lounge sofas", "Coffee tables", "Ottomans & benches"],
    // TODO: replace with additional real photos of this showroom/product range.
    gallery: [chairCoImg, lumeBrassImg, ferraraImg],
  },
  {
    img: lumeBrassImg,
    alt: "Pendant lamps and wall sconces at the Lume & Brass showroom",
    eyebrow: "Decorative Lighting Store",
    name: "Lume & Brass",
    meta: "Kalyani Nagar · Showroom",
    tags: ["Pendant lights", "Wall sconces", "Table lamps", "Outdoor lighting"],
    gallery: [lumeBrassImg, ferraraImg, maatiImg],
  },
  {
    img: ferraraImg,
    alt: "Brass handles and soft-close hinges from Ferrara Hardware Studio",
    eyebrow: "Hardware & Fittings Partner",
    name: "Ferrara Hardware Studio",
    meta: "Shivajinagar · Authorised Hettich & Blum",
    tags: ["Handles & knobs", "Hinges & channels", "Profiles", "Locks & latches"],
    gallery: [ferraraImg, maatiImg, chairCoImg],
  },
  {
    img: maatiImg,
    alt: "Ceramics, stone and material objects curated by Maati Objects & Ceramics",
    eyebrow: "Décor & Objects Store",
    name: "Maati Objects & Ceramics",
    meta: "Baner · Studio pottery",
    tags: ["Vases & planters", "Tableware", "Wall art", "Rugs & textiles"],
    gallery: [maatiImg, chairCoImg, lumeBrassImg],
  },
];

const filterSteps = [
  {
    n: "01",
    title: "Factory & Workshop Audit",
    desc: "We visit, unannounced. Machinery, finishing quality, raw material stock and workforce are scored before any conversation.",
  },
  {
    n: "02",
    title: "Sample Benchmarking",
    desc: "Their product is tested against our benchmark piece — hinges cycled, shutters measured, seams inspected.",
  },
  {
    n: "03",
    title: "Trial Work Package",
    desc: "One small package on a live project. Delivery time, site behaviour and finish are watched closely.",
  },
  {
    n: "04",
    title: "Annual Review",
    desc: "Every partner is re-scored each year. Standards slip, partnership ends. That is why the list stays strong.",
  },
];

export default function Specialists() {
  // Lightbox state for the "Furniture & Décor Partners" gallery
  const [lightbox, setLightbox] = useState({
    open: false,
    partnerIndex: 0,
    imageIndex: 0,
  });

  const openLightbox = (partnerIndex, imageIndex = 0) => {
    setLightbox({ open: true, partnerIndex, imageIndex });
  };

  const closeLightbox = useCallback(() => {
    setLightbox((prev) => ({ ...prev, open: false }));
  }, []);

  const showPrevImage = useCallback(() => {
    setLightbox((prev) => {
      const total = decorPartners[prev.partnerIndex].gallery.length;
      return { ...prev, imageIndex: (prev.imageIndex - 1 + total) % total };
    });
  }, []);

  const showNextImage = useCallback(() => {
    setLightbox((prev) => {
      const total = decorPartners[prev.partnerIndex].gallery.length;
      return { ...prev, imageIndex: (prev.imageIndex + 1) % total };
    });
  }, []);

  // Keyboard navigation: Esc to close, arrows to move between images
  useEffect(() => {
    if (!lightbox.open) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") showPrevImage();
      if (e.key === "ArrowRight") showNextImage();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightbox.open, closeLightbox, showPrevImage, showNextImage]);

  const activePartner = decorPartners[lightbox.partnerIndex];

  return (
    <div className="dw-specialists">
      {/* Hero */}
      <section className="dw-hero">
        <div className="dw-hero-media">
          <img
            src={workshopPromiseImg}
            alt="Specialist craftsman at work in a Dwellora partner workshop"
          />
        </div>
        <div className="dw-hero-overlay" />
        <div className="dw-hero-content">
          <p className="dw-eyebrow dw-hero-eyebrow" style={{ fontSize: 10 }} >Our Specialists</p>
          <h1>The companies behind your home.</h1>
          <p>
            Dwellora keeps design and coordination in-house — and gives every
            product to a partner company that does that one thing better than
            anyone else. Here is who they are, and what they make for you.
          </p>

          <div className="dw-hero-stats">
            {stats.map((s) => (
              <div key={s.label} className="dw-hero-stat">
                {/* <p className="dw-hero-stat-value">{s.value}</p> */}
                <p className="dw-hero-stat-value" style={{ fontSize: 40 }}>{s.value}</p>
                <p className="dw-eyebrow dw-hero-stat-label" style={{ marginTop: 0 }}  >{s.label}</p>
              </div>
            ))}
          </div>

          <div className="dw-hero-collab">
            <p className="dw-eyebrow dw-hero-collab-label">In collaboration with</p>
            <div className="dw-marquee">
              <div className="dw-marquee-track">
                {[...collaborators, ...collaborators].map((c, i) => (
                  <div className="dw-marquee-pill" key={`${c.initials}-${i}`}>
                    <span className="dw-marquee-initials">{c.initials}</span>
                    <span className="dw-marquee-name">{c.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* <SiteCrews /> */}


      {/* Category 01 — Manufacturers */}
      <section className="dw-section">
        <div className="dw-section-header">
          <div>
            <p className="dw-eyebrow">Category 01</p>
            <h2 className="dw-section-title">The Manufacturers</h2>
          </div>
          <p className="dw-section-desc">
            Factory partners who build the fixed core of your home — kitchens,
            wardrobes, upholstery and furniture — before anything reaches the
            site.
          </p>
        </div>

        <div className="dw-mfr-grid">
          {manufacturers.map((m) => (
            <article key={m.name} className="dw-mfr-card">
              <div className="dw-mfr-img">
                <img src={m.img} alt={m.alt} width={1200} height={1504} loading="lazy" />
              </div>
              <div className="dw-mfr-body">
                <p className="dw-eyebrow">{m.eyebrow}</p>
                <h3 className="dw-mfr-name">{m.name}</h3>
                <p className="dw-mfr-meta">{m.meta}</p>
                <p className="dw-mfr-desc">{m.desc}</p>
                <div className="dw-tag-list">
                  {m.tags.map((t) => (
                    <span key={t} className="dw-tag">
                      {t}
                    </span>
                  ))}
                </div>
                <a href="#" className="dw-portfolio-link">
                  View Portfolio
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Category 02 — Consultants */}
      <section className="dw-section--card">
        <div className="dw-section">
          <div className="dw-section-header">
            <div>
              <p className="dw-eyebrow">Category 02</p>
              <h2 className="dw-section-title">The Consultants</h2>
            </div>
            <p className="dw-section-desc">
              Specialists who decide the invisible things — light, load,
              water and views — before the manufacturers begin.
            </p>
          </div>

          <div className="dw-consult-grid">
            {consultants.map((c) => (
              <article key={c.name} className="dw-consult-card">
                <p className="dw-eyebrow">{c.eyebrow}</p>
                <h3 className="dw-consult-name">{c.name}</h3>
                <p className="dw-consult-desc">{c.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Category 03 — Furniture & Décor Partners */}
      <section className="dw-section">
        <div className="dw-section-header">
          <div>
            <p className="dw-eyebrow">Category 03</p>
            <h2 className="dw-section-title">Furniture &amp; Décor Partners</h2>
          </div>
          <p className="dw-section-desc">
            Showrooms and studios we curate the loose layer from — chairs,
            lights, hardware and objects that finish the home.
          </p>
        </div>

        <div className="dw-decor-grid">
          {decorPartners.map((d, partnerIndex) => (
            <article key={d.name} className="dw-decor-card">
              <button
                type="button"
                className="dw-decor-img dw-decor-img-btn"
                onClick={() => openLightbox(partnerIndex, 0)}
                aria-label={`View more photos of ${d.name}`}
              >
                <img src={d.img} alt={d.alt} width={1200} height={1504} loading="lazy" />
                <span className="dw-decor-img-hint">View gallery</span>
              </button>
              <div className="dw-decor-body">
                <p className="dw-eyebrow">{d.eyebrow}</p>
                <h3 className="dw-decor-name">{d.name}</h3>
                <p className="dw-decor-meta">{d.meta}</p>
                <ul className="dw-decor-list">
                  {d.tags.map((t) => (
                    <li key={t}>{t}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Category 04 — The Filter */}
      <section className="dw-section--bordered">
        <div className="dw-section">
          <p className="dw-eyebrow">Category 04 · The Filter</p>
          <h2 className="dw-section-title" style={{ maxWidth: "42rem" }}>
            How a company earns its place on this page
          </h2>

          <div className="dw-filter-grid">
            {filterSteps.map((f) => (
              <div key={f.n} className="dw-filter-card">
                <span className="dw-filter-num">{f.n}</span>
                <h3 className="dw-filter-title">{f.title}</h3>
                <p className="dw-filter-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* The Promise */}
      <section className="dw-promise">
        <div className="dw-promise-grid">
          <div className="dw-promise-img">
            <img
              src={workshopPromiseImg}
              alt="Specialist craftsman working on a furniture panel in the workshop"
              width={1200}
              height={1504}
              loading="lazy"
            />
          </div>
          <div className="dw-promise-copy">
            <p className="dw-eyebrow dw-promise-eyebrow">The Promise</p>
            <h2 className="dw-promise-title">
              Fourteen companies. One person you call.
            </h2>
            <p className="dw-promise-desc">
              You never manage this network — Dwellora does. Vendor
              selection, drawings, approvals, factory checks, delivery
              windows and site sequencing all run through us. You get one
              schedule, one design language and one accountable team.
            </p>
            <a href="/contact" className="dw-promise-cta">
              Get a Free Quote
            </a>
          </div>
        </div>
      </section>

      {/* Lightbox — Furniture & Décor Partners gallery */}
      {lightbox.open && (
        <div
          className="dw-lightbox-overlay"
          role="dialog"
          aria-modal="true"
          aria-label={`${activePartner.name} photo gallery`}
          onClick={closeLightbox}
        >
          <div className="dw-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="dw-lightbox-close"
              onClick={closeLightbox}
              aria-label="Close gallery"
            >
              &times;
            </button>

            <div className="dw-lightbox-stage">
              <img
                key={lightbox.imageIndex}
                className="dw-lightbox-img"
                src={activePartner.gallery[lightbox.imageIndex]}
                alt={`${activePartner.name} — photo ${lightbox.imageIndex + 1} of ${activePartner.gallery.length}`}
              />
            </div>

            {activePartner.gallery.length > 1 && (
              <div className="dw-lightbox-controls">
                <button
                  type="button"
                  className="dw-lightbox-nav dw-lightbox-nav--prev"
                  onClick={showPrevImage}
                  aria-label="Previous image"
                >
                  &#8249;
                </button>
                <button
                  type="button"
                  className="dw-lightbox-nav dw-lightbox-nav--next"
                  onClick={showNextImage}
                  aria-label="Next image"
                >
                  &#8250;
                </button>
              </div>
            )}

            <div className="dw-lightbox-footer">
              <p className="dw-lightbox-name">{activePartner.name}</p>
              {activePartner.gallery.length > 1 && (
                <p className="dw-lightbox-counter">
                  {lightbox.imageIndex + 1} / {activePartner.gallery.length}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
